import styled from "styled-components";
import { WIDE_DESKTOP } from "../../../styles/breakpoints";

export const Container = styled.div`
  width: 100%;
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  padding: 1rem 0;
  background: #ffffff;
  box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 1.625rem 3.125rem;
  z-index: 10;
  position: relative;
`;

export const Form = styled.div<{ grid?: boolean }>`
  padding: 2rem 1rem;
  flex-wrap: wrap;
  width: 100%;

  @media (min-width: ${WIDE_DESKTOP}) {
    padding: 0;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0 0.5rem;

  @media (min-width: ${WIDE_DESKTOP}) {
    &:not(:first-child) {
      padding-top: 2rem;
    }
  } ;
`;

export const InputContent = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  width: 100%;
`;

export const Title = styled.p`
  margin: 0.5rem 0 0.5rem 0;
  font-size: 0.875rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primaryBlue.main};
`;

export const TitleWithInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.primaryBlue.main};
  font-size: 0.875rem;
`;

export const CheckboxList = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-height: 14.125rem;

  .form-field {
    margin: 0.5rem 1rem 0.5rem 0;
  }
`;

export const SingleCheck = styled.div`
  padding: 0.5rem 0;
`;

export const MultipleRange = styled.div`
  position: relative;

  input {
    position: absolute;
  }
`;

export const TextFieldContent = styled.div`
  margin-bottom: 1.75rem;
  position: relative;
  width: 350px;
  @media screen and (min-width: ${WIDE_DESKTOP}) {
    margin-bottom: 0;
  }
`;

export const ViewDesktop = styled.div`
  display: none;
  background: #ffffff;

  @media (min-width: ${WIDE_DESKTOP}) {
    display: flex;
  }
`;

export const Line = styled.div`
  align-items: center;
  background: #d9d9d9;
  display: flex;
  width: 1.9rem;
  height: 0.063rem;
  margin-left: 0.3rem;
  margin-right: 0.3rem;
`;

export const Range = styled.div`
  display: flex;
  align-items: center;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 340px;
  margin-top: 1.5rem;
`;

export const ForcastConclusionContainer = styled.div`
    display: flex;
    gap: 1rem;
    width: 100%;

    #forecast {
        width: 100%;
    }
`;

export const Expand = styled.div<{ rotate: boolean }>`
  background-color: #fff;
  padding: 10px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  box-shadow: 0 0 0 1px #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  svg {
    transform: ${({ rotate }) => (rotate ? "rotate(0)" : "rotate(180deg)")};
    transition: 0.3s;
    transition-timing-function: ease-in;
  }
  :hover {
    cursor: pointer;
  }
`;
export const Checkbox = styled.input`
  border: none !important;
  :checked {
    background-color: #f5edff !important;
    accent-color: ${({ theme }) => theme.colors.primaryBlue.main};
    color: #fff !important;
  }
`;

export const RadiusInput = styled.input`
  width: 100%;
  accent-color: ${({ theme }) => theme.colors.primaryBlue.main};
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 1rem 0;
`;

export const CheckboxLabel = styled.div`
  width: 300px;
  font-size: 0.875rem;
`;

export const DataList = styled.datalist`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  writing-mode: vertical-lr;
  width: 100%;
  & >option {
    font-size: .800rem;
  }
`;

export const TwoFields = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
`;

export const RadioContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 0.5rem;
    gap: 0.25rem;

    label {
        display: flex;
        align-items: center;
        gap: 0.4rem;
    }

    span {
        font-size: 0.875rem;
    }

    input[type="radio"] {
        accent-color: ${({ theme }) => theme.colors.primaryBlue.main};
    }
`;